import FontPreloader from '@/src/components/meta/FontPreloader.jsx';
import PropTypes from 'prop-types';
// components/SEO.jsx
import React from 'react';
import { theme } from '@/styles/theme/index.jsx';
import Head from 'next/head';

export const metadata = {
	title: 'ECO Sourcing Limited',
	description:
		'Eco Sourcing Limited believes that good quality has no boundary to go the extra mile to excel and stand out from the competitors.',
	themeColor: '#5D8D3B',
	manifest: '/manifest.json',
};

const SEO = ({
	title,
	description,
	keywords,
	author,
	url,
	image,
	twitterHandle,
	facebookVerification,
	googleVerification,
	canonical,
	fav,
}) => {
	return (
		<head>
			{/* Basic Meta Tags */}
			<meta charSet="UTF-8" />
			<meta name="viewport" content="width=device-width, initial-scale=1" />
			<meta name="description" content={description} />
			<meta name="keywords" content={keywords} />
			<meta name="author" content={author} />
			<meta content={theme.colors.hover} name="theme-color" />
			<link rel="manifest" href="/manifest.json" />

			{/* Open Graph Meta Tags */}
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:image" content={image} />
			<meta property="og:url" content={url} />
			<meta property="og:type" content="website" />

			{/* Twitter Card Meta Tags */}
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={title} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:image" content={image} />
			<meta name="twitter:site" content={twitterHandle} />
			<meta name="twitter:creator" content={twitterHandle} />
			<meta
				name="format-detection"
				content="telephone=no, date=no, emailyarn de=no, address=no"
			/>
			{/* Favicon and Apple Touch Icon */}
			<link rel="icon" type="image/png" href={fav || '/images/static/fav.svg'} />
			<link rel="apple-touch-icon" sizes="180x180" href={fav || '/images/static/fav.svg'} />
			<FontPreloader />
			{/* Canonical Link */}
			{canonical && <link rel="canonical" href={canonical} />}

			{/* Additional Meta Tags */}
			{facebookVerification && (
				<meta
					name="facebook-domain-verification"
					content={facebookVerification}
				/>
			)}
			{googleVerification && (
				<meta
					name="google-site-verification"
					content={googleVerification}
				/>
			)}
			<title>{title}</title>
		</head>
	);
};

SEO.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	keywords: PropTypes.string,
	author: PropTypes.string,
	url: PropTypes.string.isRequired,
	image: PropTypes.string.isRequired,
	fav: PropTypes.string.isRequired,
	twitterHandle: PropTypes.string,
	facebookVerification: PropTypes.string,
	googleVerification: PropTypes.string,
	canonical: PropTypes.string,
};

SEO.defaultProps = {
	keywords: '',
	author: '',
	twitterHandle: '',
	facebookVerification: '',
	googleVerification: '',
	canonical: '',
};

export default React.memo(SEO);
